import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=6314219a&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=6314219a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6314219a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6314219a')) {
      api.createRecord('6314219a', component.options)
    } else {
      api.reload('6314219a', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=6314219a&scoped=true", function () {
      api.rerender('6314219a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/openAI/components/Statistics.vue"
export default component.exports